<template>
<div>
    <v-row hidden>
        <v-col cols="12" sm="4" md="3">
            <v-text-field v-model="sms.tel" label="เบอร์โทร 66xxxxxxxxx" outlined dense></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="3">
            <v-select :items="[
                        'Confirm  case',
                        'Confirm time to onsite',
                        'Infirm wait part',
                    ]" label="Code Claim" menu-props="auto" v-model="sms.type" outlined dense hide-details></v-select>
        </v-col>
        <v-col cols="12" sm="4" md="3">
            <v-btn color="" class="primary--text" block @click="test_sms()">
                Test SMS
            </v-btn>
        </v-col>
        <v-col cols="12">
            <hr />
        </v-col>
    </v-row>

        <v-row no-gutters>
            <v-col cols="12">
                <h1 class="mb-3 headline font-weight-light">
                    Monitor GPS
                </h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        GPS Start ผิดพลาด
                        <v-btn
                            x-small
                            fab
                            class="ml-3"
                            :color="
                                chk_data_main_gps == false
                                    ? 'green accent-2'
                                    : 'amber'
                            " @click="get_data_gps()">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-btn icon @click="show = !show">
                        <v-icon>{{
                                show ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>
                    <span class="red--text font-fix-11">(แก้ไขข้อมูลล่าสุดวันที่ 18/03/64)</span>
                </v-card-subtitle>
                <v-expand-transition>
                    <div v-show="show">
                        <v-row>
                            <v-col cols="12">
                                <v-simple-table class="table-inv">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">
                                                    #
                                                </th>
                                                <th class="text-center">
                                                    Subcase id
                                                </th>
                                                <th class="text-center">
                                                    Branch
                                                </th>
                                                <th class="text-center">
                                                    engineer
                                                </th>
                                                <th class="text-center">
                                                    OnsiteAt
                                                </th>
                                                <th class="text-center">
                                                    GpsAt
                                                </th>
                                                <th class="text-center">
                                                    Lat - Lng Start
                                                </th>
                                                <th class="text-center">
                                                    Lat - Lng End
                                                </th>
                                                <th class="text-center">
                                                    KM.
                                                </th>
                                                <th class="text-center">
                                                    Lat - Lng Branch
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row,
                                                    index) in data_main_gps" :key="index">
                                                <td class="text-center">
                                                    {{ index + 1 }}.
                                                </td>
                                                <td class="text-center">
                                                    {{ row.subcase_id }}
                                                </td>
                                                <td>
                                                    {{ row.branch_name }}
                                                </td>
                                                <td>
                                                    {{
                                                            row.engineer +
                                                                " " +
                                                                row.engineer_name
                                                        }}
                                                </td>
                                                <td class="text-center">
                                                    {{ row.onsite_at }}
                                                </td>
                                                <td class="text-center">
                                                    {{ row.gps_at }}
                                                </td>
                                                <td class="text-center">
                                                    <span class="green--text">{{
                                                                row.lat_start
                                                            }}</span><br />
                                                    <span class="teal--text">{{
                                                                row.lng_start
                                                            }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="green--text">{{ row.lat }}</span><br />
                                                    <span class="teal--text">{{ row.lng }}</span>
                                                </td>

                                                <td class="text-center">
                                                    {{ row.km }}
                                                </td>
                                                <td class="text-center">
                                                    <span class="green--text">{{
                                                                row.branch_lat
                                                            }}</span><br />
                                                    <span class="teal--text">{{
                                                                row.branch_lng
                                                            }}</span>
                                                </td>
                                            </tr>
                                            <br />
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </div>
                </v-expand-transition>
            </v-card>
        </v-col>
        <v-col cols="12">
            <v-card>
                <v-card-title>
                    ดึงเคสกลับ
                    <v-spacer></v-spacer>
                    <v-btn icon @click="show2 = !show2">
                        <v-icon>{{
                                show2 ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>
                    <v-row>
                        <v-col cols="12" sm="5" md="3">
                            <v-dialog ref="dialog" v-model="modal" :return-value.sync="form.date" persistent width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="form.date" label="วันที่" prepend-icon="" readonly v-on="on" outlined dense></v-text-field>
                                </template>
                                <v-date-picker v-model="form.date" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="
                                                $refs.dialog.save(form.date)
                                            ">OK</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="5" md="3">
                            <v-text-field outlined dense label="รหัสพนักงาน" v-model="form.engineer" v-on:keyup.enter="get_data()"></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-btn x-small fab :color="
                                        chk_data_main == false
                                            ? 'green accent-2'
                                            : 'amber'
                                    " @click="get_data()" :disabled="
                                        form.date == '' || form.engineer == ''
                                    ">
                                <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-subtitle>
                <v-expand-transition>
                    <div v-show="show2">
                        <v-row>
                            <v-col cols="12">
                                <v-simple-table class="table-inv">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">
                                                    #
                                                </th>
                                                <th class="text-center">
                                                    Subcase id
                                                </th>
                                                <th class="text-center">
                                                    Case
                                                </th>
                                                <th class="text-center">
                                                    Main Status / Sub Status
                                                </th>
                                                <th class="text-center">
                                                    Solution
                                                </th>
                                                <th class="text-center">
                                                    Lat - Lng Start
                                                </th>
                                                <th class="text-center">
                                                    Lat - Lng End
                                                </th>
                                                <th class="text-center">
                                                    Lat - Lng Branch
                                                </th>
                                                <th class="text-center">
                                                    Gps Date
                                                </th>
                                                <th class="text-center">
                                                    HappyCall
                                                </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody cla>
                                            <tr v-for="(r, ii) in data_main" :key="ii">
                                                <td class="text-center">
                                                    {{ ii + 1 }}.
                                                </td>
                                                <td class="text-center">
                                                    {{ r.subcase_id }}
                                                </td>
                                                <td>
                                                    <v-btn :disabled="
                                                                r.case_id ==
                                                                    'return-pickup' ||
                                                                    r.case_id ==
                                                                        'return'
                                                            " class="mt-1 mb-1 mr-1" :to="
                                                                '/Project/ViewCasepending/' +
                                                                    team_name +
                                                                    '/' +
                                                                    r.maincase_id +
                                                                    '/ViewDetail'
                                                            " target="_blank" small :color="
                                                                r.gps == 'ok'
                                                                    ? 'white'
                                                                    : 'red accent-2'
                                                            " rounded>
                                                        <span :class="
                                                                    r.case_id !=
                                                                        'return-pickup' &&
                                                                    r.case_id !=
                                                                        'return'
                                                                        ? 'primary--text mr-1'
                                                                        : 'green--text mr-1'
                                                                ">{{
                                                                    r.case_id +
                                                                        "-" +
                                                                        r.subcase
                                                                }}
                                                        </span>
                                                    </v-btn>

                                                    <v-chip v-if="
                                                                r.case_id !=
                                                                    'return-pickup' &&
                                                                    r.case_id !=
                                                                        'return'
                                                            " small class="mt-1 mb-1 mr-1">{{
                                                                r.project_name
                                                            }}</v-chip>
                                                    <v-chip class="mt-1 mb-1" small v-if="
                                                                r.case_id !=
                                                                    'return-pickup' &&
                                                                    r.case_id !=
                                                                        'return'
                                                            ">{{
                                                                r.site_name
                                                            }}</v-chip>
                                                </td>

                                                <td>
                                                    <span class="blue--text">
                                                        {{
                                                                r.main_status_name
                                                            }}</span>
                                                    <br />
                                                    <span class="indigo--text">{{
                                                                r.sub_status_name
                                                            }}</span>
                                                </td>

                                                <td>
                                                    <span class="font-fix-13">{{
                                                                r.solution
                                                            }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="green--text">{{
                                                                r.lat_start
                                                            }}</span><br />
                                                    <span class="teal--text">{{
                                                                r.lng_start
                                                            }}</span>
                                                </td>

                                                <td class="text-center">
                                                    <span class="green--text">{{ r.lat }}</span>
                                                    <br />
                                                    <span class="teal--text">{{ r.lng }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="green--text">{{
                                                                r.branch_lat
                                                            }}</span><br />
                                                    <span class="teal--text">{{
                                                                r.branch_lng
                                                            }}</span>
                                                </td>
                                                <td class="text-center">
                                                    {{ r.gps_date }}
                                                </td>
                                                <td class="text-center">
                                                    <v-chip x-small color="amber" v-if="
                                                                r.is_happyCall
                                                            ">{{
                                                                r.is_happyCall
                                                            }}</v-chip><br />
                                                    <v-chip x-small v-if="r.hpc_status">{{
                                                                r.hpc_status
                                                            }}</v-chip>
                                                </td>
                                                <td class="text-center">
                                                    <v-btn x-small fab color="blue accent-1" @click="
                                                                save_return_case(
                                                                    r.subcase_id
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                >mdi-rotate-left-variant</v-icon
                                                            >
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                <br />
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

    <back-to-top bottom="50px" right="50px">
        <v-btn small fab color="deep-purple lighten-2">
            <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
        </v-btn>
    </back-to-top>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {
    mapState,
    mapMutations
} from "vuex"

import Maps from './test_service.vue'
const url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    name: 'Mileage',
    components: {
        Maps
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),

    },
    beforeMount() {
        this.tk = {
            headers: {
                Authorization: "Bearer " + localStorage.token
            },
        }
    },
    mounted() {
        this.get_data_gps()
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data_gps() {
            this.chk_data_main_gps = true
            await axios.get(url + "it/task/monitor-gps").then((response) => {
                this.chk_data_main_gps = false
                this.data_main_gps = response.data
            })
        },
        async get_data() {
            this.chk_data_main = true
            await axios
                .post(url + "it/task/search-onsite", this.form)
                .then((response) => {
                    this.chk_data_main = false
                    this.data_main = response.data
                    this.show2 = true
                })
        },
        save_return_case(subcase_id) {
            let send = {
                date: this.form.date,
                engineer: this.form.engineer,
                subcase_id: subcase_id,
            }
            this.$swal({
                title: "Are you sure ?",
                text: "ต้องการจะดึงเคสกลับใช้หรือไม่",
                icon: "warning",

                buttons: {
                    cancel: true,
                    text: "SAVE",
                },
            }).then((conf) => {
                if (conf) {
                    axios
                        .post(url + "it/task/save-return-case", send, this.tk)
                        .then((response) => {
                            this.mutatesnackbar()
                            this.get_data()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },

        async test_sms() {
            this.dialog_loading = true
            let str
            if (this.sms.type == "Confirm  case") {
                str =
                    "HP หมายเลขเคส 5123467852 - ขณะนี้ทีมวิศวกร HP ได้รับเคสที่ท่านแจ้งเข้ามาแล้ว ทางเราจะติดต่อกลับอีกครั้งเมื่อได้รับอะไหล่ค่ะ"
            } else if (this.sms.type == "Confirm time to onsite") {
                str =
                    "HP หมายเลขเคส 5123467852 - ขณะนี้ทางวิศวกร HP ได้รับอะไหล่เรียบร้อยแล้ว จะทำการติดต่อเพื่อนัดหมายวันเวลาเข้าซ่อม หากภายในวันนี้ไม่ได้รับการติดต่อจากวิศวกรของเรา กรุณาติดต่อเข้ามาที่ 020781589 ค่ะ"
            } else if (this.sms.type == "Infirm wait part") {
                str =
                    "HP หมายเลขเคส 5123467852 - ขออภัยในความล่าช้าค่ะ ตอนนี้อะไหล่ขาดสต็อค คาดว่าใช้ระยะเวลารออะไหล่ประมาณ XX วัน หากท่านต้องการความช่วยเหลืออื่นๆ กรุณาติดต่อเข้ามาที่ 020781589 ค่ะ"
            }

            str = str
                .split("")
                .map((char) => addZeros(char.charCodeAt(0).toString(16)))
                .join("")
            // console.log(str)
            function addZeros(str) {
                return ("0000" + str).slice(-4)
            }

            let data_x = {
                str: str,
                tel: this.sms.tel,
            }
            await axios
                .post(url + "partner/sms-online", data_x, this.tk)
                .then((response) => {
                    console.log(response.data)
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
       handleLocationChange(newLocation) {
      // Retrieve the latitude and longitude values from the event payload
      this.latitude = newLocation.latitude;
      this.longitude = newLocation.longitude;
    },
    retrieveLocation() {
      // Retrieve the current latitude and longitude values from the Maps component
      // (Assuming you have access to the child component instance)
      const mapsComponent = this.$refs.mapsComponent; // Assuming you set a ref on the Maps component
      const currentLocation = mapsComponent.getCurrentLocation();
      // Do something with the currentLocation
    //   console.log('Current Location:', currentLocation);
    },
    setlatlong(){
        

  
        // console.log('set lat ',this.lat)
        // console.log('set long ',this.long)
        // console.log('count',)
        
        

        
    }

    },
    data() {
        return {
            tk: null,
            data_main_gps: [],
            chk_data_main_gps: false,
            chk_data_main: false,
            data_main: [],
            show: true,
            show2: false,
            show3: false,

            form: {
                date: "",
                engineer: "",
            },
            modal: false,
            modal1: false,
            text: "Success, Your work has been saved",
            team_name: localStorage.team_name,
            sms: {
                tel: "66",
                type: "",
            },
            dialog_loading: false,
        }
    },
}
</script>

<style>
.map-container {
    width: 100%;
}

.input {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    /* Ensures padding and border are included in the width */
    transition: border-color 0.3s ease;
    /* Smooth transition for border color change */
}

/* Hover and Focus Styles */
.input:hover,
.input:focus {
    border-color: #66afe9;
    /* Change border color on hover/focus */
    outline: none;
    /* Remove default focus outline */
}

.map {
    height: 400px;
    margin-bottom: 20px;
}

.location-info {
    background-color: #f9f9f9;
    padding: 10px;
    border-radius: 5px;
}

.location-info div {
    margin-bottom: 5px;
}
</style>
